import { FC, useEffect, useState } from 'react'

/* Libraries */
import ReactModal from 'react-modal'

/* Helpers */
import { layer2Links } from '../lib/constants'
import { getSigners, Signer } from '../api'
import { convertToETH, reduceAddress } from '../lib/helpers'

/* Components */
import { Loading } from '../components/Loading'

/* Assets */
import { Helmet } from 'react-helmet'

ReactModal.setAppElement('#root')

const AddressManagementPage: FC = () => {
  const [isFetchingAddresses, setIsFetchingAddresses] = useState<null | boolean>(null)
  const [addresses, setAddresses] = useState<null | Signer[]>(null)

  useEffect(() => {
    fetchSigners()
  }, [])

  const fetchSigners = () => {
    setIsFetchingAddresses(true)
    setAddresses(null)

    getSigners()
      .then((addresses) => {
        if (!addresses) return
        setAddresses(addresses)
      })
      .catch((error) => console.error(error))
      .finally(() => setIsFetchingAddresses(false))
  }

  return (
    <div className={'admin-table addresses'}>
      <Helmet>
        <title>POAP - Admin addresses management</title>
        <meta property="og:title" content="POAP - Admin addresses management" />
      </Helmet>
      <h2>Admin addresses management</h2>
      <div className={'row table-header visible-md'}>
        <div className={'col-md-1 center'}>#</div>
        <div className={'col-md-3'}>Address</div>
        <div className={'col-md-3'}>Pending Txs</div>
        <div className={'col-md-3 center'}>Balance (ETH)</div>
        <div className={'col-md-2 center'}>Gas Price (GWei)</div>
      </div>
      <div className={'admin-table-row'}>
        {isFetchingAddresses && <Loading />}
        {addresses &&
          addresses.map((address, i) => {
            return (
              <div className={`row`} key={address.id}>
                <div className={'col-md-1 center'}>
                  <span className={'visible-sm'}>#</span>
                  {address.id}
                </div>
                <div className={'col-md-3'}>
                  <span className={'visible-sm'}>Address: </span>
                  <a href={layer2Links.address(address.signer)} target="_blank">
                    {reduceAddress(address.signer)}
                  </a>
                </div>
                <div className={'col-md-3 center'}>
                  <span className={'visible-sm'}>Pending Txs: </span>
                  {address.pending_transactions_count}
                </div>
                <div className={'col-md-3 center'}>
                  <span className={'visible-sm'}>Balance (ETH): </span>
                  {Math.round(convertToETH(address.balance) * 1000) / 1000}
                </div>
              </div>
            )
          })}
      </div>
    </div>
  )
}

export { AddressManagementPage }
